import CloseIcon from '@/common/assets/icons/closeIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const Chips = ({ text, onClick }: { text: string; onClick: () => void }) => {
  return (
    <Box
      display="inline-flex"
      padding="4px 8px"
      borderRadius="8px"
      alignItems="center"
      gap="0.5rem"
      backgroundColor="gray-2"
      mx="4px"
    >
      <Typography color="black-1">{text}</Typography>
      <CloseIcon
        stroke={token('colors.black-3')}
        onClick={onClick}
        className={css({ cursor: 'pointer' })}
      />
    </Box>
  );
};

export default Chips;
